export default __webpack_public_path__ + "static/media/dsa.df7e2c1c.jfif";